import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import type { Localized } from '@/packages/explore/types'

/** Picks the variant for `language`; anything that is not Hungarian reads the English one. */
export function pickLocalized(value: string | Localized, language: string): string {
  if (typeof value === 'string') return value
  return language.toLowerCase().startsWith('hu') ? value.hu : value.en
}

/** `pickLocalized` bound to the active i18next language. */
export function useLocalize(): (value: string | Localized) => string {
  const { i18n } = useTranslation()
  const language = i18n.language

  return useCallback((value: string | Localized) => pickLocalized(value, language), [language])
}
